export const BASE_SAVES_PATH = "/favorites/saves"
